import {dataURItoFile, downloadResource, getHeader} from "./common";
import {getServerUrl} from "./dataset";
import config from "../app.config";


const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));


export async function submitForExtraction(file_id, extractor_name, statementType, pdf_file_json){
	// submits file for extraction and returns true if extraction is successful, else returns false
	console.log("submitForExtraction", file_id, extractor_name, statementType, pdf_file_json);
	let body = {};
	if (extractor_name === config.rct_extractor){
		body = {"extractor": extractor_name, "parameters": {"statement": statementType, "pdf_fileid": pdf_file_json.fileid, "pdf_filename": pdf_file_json.filename}};
	}
	else{
		body = {"extractor": extractor_name};
	}
	
	const extraction_response = await extractionRequest(file_id, body);
	console.log("Extraction response for extractor ", extractor_name, extraction_response);
	if (extraction_response !== null && extraction_response.status === "OK") {
		return true;
	}
	else {
		return false;
	}
}


async function extractionRequest(file_id, body_data) {
	// Clowder API call to submit a file for extraction - proxied through Express server
	const extractions_url = getServerUrl(`/api/files/${file_id}/extractions`);
	const body = JSON.stringify(body_data);
	const authHeader = getHeader();
	authHeader.append("Accept", "application/json");
	authHeader.append("Content-Type", "application/json");

	let extraction_response = null;

	const extractionRequest_loop = async () => {

		const response = await fetch(extractions_url, {
			method: "POST",
			mode: "cors",
			headers: authHeader,
			body: body,
		});
		extraction_response = await response.json(); // JSONObj {"status":"OK","job_id":"string"}
		//const extraction_response_text = await response.text();
		//console.log(extraction_response_text);
		if (response.status === 200) {
			// return {"status":"OK","job_id":"string"}
		} else if (response.status === 409){
			// TODO handle error
			await sleep(30000);
			await extractionRequest_loop();
		}
		else {
			// TODO handle error
			extraction_response.status = "FAIL";
		}
		return extraction_response;

	};

	extraction_response = await extractionRequest_loop();
	return extraction_response;

}


export async function fetchFileMetadata(id) {
	const url = getServerUrl(`/api/files/${id}/metadata?superAdmin=true`);
	const response = await fetch(url, {mode: "cors"});
	if (response.status === 200) {
		return await response.json();
	} else if (response.status === 401) {
		// TODO handle error
		return {};
	} else {
		// TODO handle error
		return {};
	}
}


export async function checkExtractionStatus(file_id){
	// Clowder API call to check extraction status of a file - proxied through Express server
	const extractions_status_url = getServerUrl(`/api/extractions/${file_id}/statuses`);
	const authHeader = getHeader();
	// authHeader.append("Accept", "*/*");
	const response = await fetch(extractions_status_url, {method:"GET", mode: "cors", headers:authHeader});
	if (response.status === 200){
		//{"ncsa.file.digest": "DONE", "ncsa.rctTransparencyExtractor": "DONE", "Status": "Done"}
		return await response.json();
	} else if (response.status === 401) {
		// TODO handle error
		return {};
	} else if (response.status === 500){
		// TODO handle error
		return {};
	}
	else {
		// TODO handle error
		return {};
	}

}

// Not used
export async function checkExtractionStatusLoop(file_id, extractor, interval){
	// check extraction status of a file in loop. Check status every interval seconds

	let extraction_status = false;

	const status_check_loop = async () => {
		const extractions_data = await checkExtractionStatus(file_id);
		const extractions_data_status = extractions_data["Status"];
		const extractions_data_extractor = extractions_data[extractor];


		if (extractions_data_status === "Done"){
			if (extractions_data_extractor === "DONE"){
				extraction_status = true;
			}
			else {
				try {
					const extractions_data_extractor_message = extractions_data_extractor.split(".");
					if (extractions_data_extractor_message[0] === "StatusMessage") {
						// check the status message from extractor
						const extractor_message = extractions_data_extractor_message[1].split(":");
						if (extractor_message[0] === "error") {
							extraction_status = false;
						}
						else {
							await sleep(interval);
							await status_check_loop();
						}

					}
				} catch (e) {
					extraction_status = false;
				}
			}
		}
		else if (extractions_data_status === "Processing") {
			await sleep(interval);
			await status_check_loop();
		}
	}; // status_check_loop end

	if (file_id !== null){
		await status_check_loop();
		return extraction_status;
	}
	else {
		return extraction_status;
	}
}


export async function uploadFile(formData, selectedDatasetId) {
	const endpoint = getServerUrl(`/api/datasets/${selectedDatasetId}/files?superAdmin=true`);
	const body = new FormData();
	formData.map((item) => {
		if (item["file"] !== undefined) {
			body.append("file", dataURItoFile(item["file"]));
		}
	});

	const response = await fetch(endpoint, {
		method: "POST",
		mode: "cors",
		body: body,
	});

	if (response.status === 200) {
		// {id:xxx}
		// {ids:[{id:xxx}, {id:xxx}]}
		return response.json();
	} else if (response.status === 401) {
		// TODO handle error
		return {};
	} else {
		// TODO handle error
		return {};
	}
}


export async function downloadAndSaveFile(fileId, filename = null) {

	if (!filename) {
		filename = `${fileId}.zip`;
	}
	const endpoint = getServerUrl(`/api/files/${fileId}/blob?superAdmin=true`);
	const response = await fetch(endpoint, {method: "GET", mode: "cors"});

	if (response.status === 200) {
		const blob = await response.blob();
		const downloadFilename = `RCTCheck_${filename}`;
		if (window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveBlob(blob, downloadFilename);
		} else {
			const anchor = window.document.createElement("a");
			anchor.href = window.URL.createObjectURL(blob);
			anchor.download = downloadFilename;
			document.body.appendChild(anchor);
			anchor.click();
			document.body.removeChild(anchor);
		}
	} else if (response.status === 401) {
		// TODO
	} else {
		// TODO handle error
	}
	return `RCTCheck_${filename}`;
}


export async function getPreviewsRequest(file_id) {
	const previews_url = getServerUrl(`/api/files/${file_id}/getPreviews`);
	const previews_response = await fetch(previews_url, {method:"GET", mode: "cors"});
	// [{"file_id":"63e6a5dfe4b034120ec4f035","previews":[{"pv_route":"/clowder/files/63e6a5dfe4b034120ec4f035/blob","p_main":"html-iframe.js","pv_id":"63e6a5dfe4b034120ec4f035","p_path":"/clowder/assets/javascripts/previewers/html","p_id":"HTML","pv_length":"21348","pv_contenttype":"text/html"}]}]
	if (previews_response.status === 200) {
		const file_preview = await previews_response.json();
		// if (file_preview[0].file_id !== undefined){
		// 	file_preview[0].previews.map((preview) => previews_list.push(preview));
		// 	console.log("preview generated");
		// }
		//return previews_list;
		return file_preview;
	}
	else{
		return null;
	}
}


export async function getPreviewResources(fileId, preview) {
	// get all file preview resources
	const preview_config = {};
	//console.log(preview); {p_id:"HTML", p_main:"html-iframe.js", p_path:"/assets/javascripts/previewers/html", pv_contenttype:"text/html", pv_id:"64ac2c9ae4b024bdd77bbfb1",pv_length:"52434",pv_route:"/files/64ac2c9ae4b024bdd77bbfb1/blob"}
	//{"pv_route": "/clowder/api/previews/67224c2ae4b095dc59cb5fde","p_main": "thumbnail-previewer.js","pv_id": "67224c2ae4b095dc59cb5fde","p_path": "/clowder/assets/javascripts/previewers/thumbnail","p_id": "Thumbnail","pv_length": "157049","pv_contenttype": "image/png"}
	
	preview_config.previewType = preview["p_id"].replace(" ", "-").toLowerCase(); // html

	if (preview_config.previewType === "thumbnail") {
		// TODO this is a hacky way to fix file previewer extractor output for soffice converted pdf docs
		// in some cases, the file previewer extractor puts pdf file as thumbnail type. See https://github.com/clowder-framework/CONSORT-frontend/pull/91
		// Convert preview route to use proxy
		let pv_route = preview["pv_route"];
		// Convert /clowder/api/... or /clowder/files/... to /api/...
		pv_route = pv_route.replace(/^\/clowder\//, "/").replace(/^\/files\//, "/api/files/");
		if (!pv_route.startsWith("/api/")) {
			pv_route = `/api${pv_route}`;
		}
		preview_config.url = getServerUrl(`${pv_route}?superAdmin=true`);
		preview_config.fileid = preview["pv_id"];
		preview_config.previewer = `/public${preview["p_path"]}/`;
		preview_config.fileType = preview["pv_contenttype"];

		const resourceURL = getServerUrl(`/api/files/${fileId}/blob?superAdmin=true`);
		preview_config.resource = await downloadResource(resourceURL);
	}
	else {
		// Convert preview route to use proxy
		let pv_route = preview["pv_route"];
		// Convert /clowder/api/... or /clowder/files/... to /api/...
		pv_route = pv_route.replace(/^\/clowder\//, "/").replace(/^\/files\//, "/api/files/");
		if (!pv_route.startsWith("/api/")) {
			pv_route = `/api${pv_route}`;
		}
		preview_config.url = getServerUrl(`${pv_route}?superAdmin=true`);
		preview_config.fileid = preview["pv_id"];
		preview_config.previewer = `/public${preview["p_path"]}/`;
		preview_config.fileType = preview["pv_contenttype"];
		
		// Handle preview resource URL
		let pv_routes = preview["pv_route"];   // pv_route:"/files/64ac2c9ae4b024bdd77bbfb1/blob"
		if (!pv_routes.includes("/api/")) {
			try{
				const routes = pv_routes.split("files/");
				// add api endpoint in url
				pv_routes = `${routes[0]}api/files/${routes[1]}`;
			} catch (e) {
				// TODO handle error
			}
		}
		// Convert to proxy route
		pv_routes = pv_routes.replace(/^\/clowder\//, "/");
		if (!pv_routes.startsWith("/api/")) {
			pv_routes = `/api${pv_routes}`;
		}
		preview_config.pv_route = pv_routes;
		const resourceURL = getServerUrl(`${pv_routes}?superAdmin=true`);
		preview_config.resource = await downloadResource(resourceURL);
	}

	return preview_config;
}

